<template>
  <div v-if="!isRippleAdmin && developerMode == false">
    <base-header type="pattern" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-8 col-lg-6">
          <div class="row">
            <div class="col-xl-6 col-lg-6">
              <a-spin :spinning="spinner.sales">
                <stats-card title="TOTAL SALES" type="gradient-green" :sub-title="dashboard.total_sales"
                  icon="fas fa-shopping-cart" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
            <div class="col-xl-6 col-lg-6">
              <a-spin :spinning="spinner.sales">
                <stats-card title="TOTAL RETURNS" type="gradient-red" :sub-title="dashboard.total_return"
                  icon="fas fa-undo" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-xl-6 col-lg-6">
              <a-spin :spinning="spinner.orders">
                <stats-card title="TOTAL FULFILLED ORDERS" type="gradient-info" :sub-title="dashboard.total_fulfilled"
                  icon="fas fa-clipboard-check" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
            <div class="col-xl-6 col-lg-6">
              <a-spin :spinning="spinner.orders">
                <stats-card title="TOTAL PENDING ORDERS" type="gradient-orange" :sub-title="dashboard.total_pending"
                  icon="fas fa-clipboard-list" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6">
          <a-spin :spinning="spinner.terminals" wrapperClassName="h-100">
            <stats-card title="ACTIVE TERMINALS" type="gradient-green" :sub-title="dashboard.total_terminals"
              icon="fas fa-desktop" class="mb-4 mb-xl-0 p-2 active-terminals" title-size="h2" sub-title-size="display-1">
            </stats-card>
          </a-spin>
        </div>
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-6 col-lg-6" @click="redirectUser('invoices')">
          <a-spin :spinning="spinner.invoices">
            <card header-classes="bg-transparent">
              <div slot="header" class="row align-items-center">
                <div class="col">
                  <h6 class="text-uppercase text-muted ls-1 mb-1">Invoice Processing</h6>
                  <div v-if="pieData > 0">
                    <h4 class="h3 mb-0">{{invoiceStatus.completedStats + invoiceStatus.errorStats}} / {{pieData}} Invoice Processed</h4>
                    <span class="h5 mb-0">with {{invoiceStatus.errorStats}} Errors</span>
                  </div>

                  <a-empty v-else />
                </div>
              </div>
              <canvas v-if="pieData > 0" id="myChart" width="100%" height="100%"></canvas>
            </card>
          </a-spin>
        </div>

        <div class="col-xl-6 col-lg-6" @click="redirectUser('syncs')">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Profile Syncing</h6>
                <h5 v-if="serverType == 'branch'" class="h3 mb-0">{{syncCount.profilesCount}} / {{syncCount.profilesTotal}} Profiles Synced</h5>
                <h5 v-else class="h3 mb-0">{{syncCount.siteCount}} / {{syncCount.siteTotal}} Sites Synced</h5>
              </div>
            </div>

            <div class="table-responsive px-4">
              <VueTabulator ref="tabulator" v-model="syncData" :options="syncOptions" />
            </div>
          </card>
        </div>
      </div>
      <!-- End charts-->
    </div>
  </div>
  <div v-else>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-8 col-lg-8">
          <div class="row">
            <div class="col-xl-6 col-lg-6 mt-4 mt-xl-0">
              <a-spin :spinning="spinner.accounts">
                <stats-card title="TOTAL ACCOUNT" type="gradient-green" :sub-title="dashboard.total_accounts"
                  icon="fas fa-user" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
            
            <div class="col-xl-6 col-lg-6 mt-4 mt-xl-0">
              <a-spin :spinning="spinner.sites">
                <stats-card title="TOTAL SITES" type="gradient-red" :sub-title="dashboard.total_sites"
                  icon="fas fa-location" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6 mt-4 mt-xl-0">
            <a-spin :spinning="spinner.terminal_count">
              <stats-card title="TOTAL TERMINAL" type="gradient-blue" :sub-title="dashboard.terminal_count"
                icon="fas fa-desktop" class="mb-4 mb-xl-0">
              </stats-card>
            </a-spin>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-xl-8 col-lg-8">
          <div class="row">
            <div class="col-xl-6 col-lg-6">
              <a-spin :spinning="spinner.top_accounts_by_user">
                <stats-card
                  title="TOP 5"
                  type="gradient-green"
                  :sub-title="dashboard.top_accounts_by_user"
                  icon="fas fa-users"
                  class="mb-4 mb-xl-0"
                >
                <span class="card-title text-uppercase text-muted mb-0 h5">TOP ACCOUNTS - USER</span>
                  <ul style="list-style-type: none; padding: 0; margin: 0;">
                    <li class="font-weight-bold mb-0 h2" v-for="(user, index) in topAccountsByUser" :key="index">
                      {{ user['Account Name'] }}: {{ user['User Count'] }}
                    </li>
                  </ul>
                </stats-card>
              </a-spin>
            </div>
            <div class="col-xl-6 col-lg-6 mt-4 mt-xl-0">
              <a-spin :spinning="spinner.top_accounts_by_site">
                <stats-card
                  title="TOP 5"
                  type="gradient-red"
                  :sub-title="dashboard.top_accounts_by_site"
                  icon="fas fa-sitemap"
                  class="mb-4 mb-xl-0"
                >
                <span class="card-title text-uppercase text-muted mb-0 h5">TOP ACCOUNTS - SITE</span>
                  <ul style="list-style-type: none; padding: 0; margin: 0;">
                    <li class="font-weight-bold mb-0 h2" v-for="(site, index) in topAccountsBySite" :key="index">
                      {{ site['Account Name'] }}: {{ site['Site Count'] }}
                    </li>
                  </ul>
                </stats-card>
              </a-spin>
            </div>

          </div>
        </div>
        <div class="col-xl-4 col-lg-6 mt-4 mt-xl-0">
          <a-spin :spinning="spinner.top_accounts_by_terminal">
                <stats-card
                  title="TOP 5"
                  type="gradient-blue"
                  :sub-title="dashboard.top_accounts_by_terminal"
                  icon="fas fa-computer"
                  class="mb-4 mb-xl-0"
                >
                <span class="card-title text-uppercase text-muted mb-0 h5">TOP ACCOUNTS - TERMINAL</span>
                  <ul style="list-style-type: none; padding: 0; margin: 0;">
                    <li class="font-weight-bold mb-0 h2" v-for="(terminal, index) in topAccountsByTerminal" :key="index">
                      {{ terminal['Account Name'] }}: {{ terminal['Terminal Count'] }}
                    </li>
                  </ul>
                </stats-card>
              </a-spin>
            </div>
      </div>
      <br>
      <div class="row">
        <div class="col-xl-8 col-lg-8">
          <div class="row">
            <div class="col-xl-3 col-lg-6" @click="redirectUser('30')">
              <a-spin :spinning="spinner.expiry_30_days">
                <stats-card title="EXPIRING TERMINALS (NEXT 30D)" type="gradient-green" :sub-title="dashboard.expiry_30_days" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
            
            <div class="col-xl-3 col-lg-6 mt-4 mt-xl-0" @click="redirectUser('60')">
              <a-spin :spinning="spinner.expiry_60_days">
                <stats-card title="EXPIRING TERMINALS (NEXT 60D)" type="gradient-yellow" :sub-title="dashboard.expiry_60_days" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
            <div class="col-xl-3 col-lg-6 mt-4 mt-xl-0" @click="redirectUser('90')">
              <a-spin :spinning="spinner.expiry_90_days">
                <stats-card title="EXPIRING TERMINALS (NEXT 90D)" type="gradient-red" :sub-title="dashboard.expiry_90_days"
                  class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
            <div class="col-xl-3 col-lg-6 mt-4 mt-xl-0" @click="redirectUser('365')">
              <a-spin :spinning="spinner.expiry_365_days">
                <stats-card title="EXPIRING TERMINALS (NEXT 91-365D)" type="gradient-orange" :sub-title="dashboard.expiry_365_days" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6 mt-4 mt-xl-0" @click="redirectUser('invoices')">
          <a-spin :spinning="spinner.pending_invoices">
            <stats-card title="Pending Invoices" type="gradient-blue" :sub-title="dashboard.pending_invoices"  icon="fas fa-receipt" class="mb-4 mb-xl-0">
            </stats-card>
          </a-spin>
        </div>
      </div>
    </base-header>
  </div>
</template>

<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import secureStorage from '../controllers/secureStorage.js'
  import HTTPRequest from '../controllers/httpRequest.js'
  import moment from 'moment';

  var Chart = require('chart.js');
  var myChart
  var component_x
  import {
    mapState, mapActions
  } from 'vuex'

  export default {
    computed: {
      ...mapState(['loggedIn', 'endPoint', 'serverType']),
    },
    data() {
      return {
        developerMode: secureStorage.getItem("developerMode"),
        site_type: 'ho',
        dashboard: {
          total_sales: "0",
          total_return: "0",
          total_fulfilled: "0",
          total_pending: "0",
          total_terminals: "0 / 0",
          terminal_count: "0",
          total_accounts: "0",
          total_sites: "HO: 0 | Branch: 0",
          top_accounts_by_site: "",
          top_accounts_by_user: "",
          top_accounts_by_terminal: "",
          pending_invoices:"0",
          expiry_365_days: "0",
          expiry_90_days: "0",
          expiry_60_days: "0",
          expiry_30_days: "0"

        },
        spinner: {
          sales: false,
          orders: false,
          terminals: false,
          invoices: false,
          accounts:false,
          sites:false,
          terminal_count: false,
          top_accounts_by_terminal: false,
          top_accounts_by_user:false,
          top_accounts_by_site: false,
          pending_invoices: false,
          terminal_license_expiry: false,
          expiry_365_days: false,
          expiry_90_days: false,
          expiry_60_days: false,
          expiry_30_days: false
        },
        topAccountsBySite: [],
        topAccountsByUser: [],
        topAccountsByTerminal: [],
        invoiceStatus: {
          completedStats: 0,
          unprocessedStats: 0,
          errorStats: 0
        },
        pieData: 1,
        chartOptions: {
          type: 'doughnut',
          data: {
            labels: ['Completed', 'Pending', 'Error'],
            datasets: [{
              label: '# of Invoices',
              data: [1, 1, 1],
              backgroundColor: [
                  '#2dce89',
                  '#fbb140',
                  '#eb5757'
              ],
              borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)'
              ],
              borderWidth: 1
            }]
          },
          options: {}
        },
        syncData: [],
        syncOptions: {
          layout:"fitDataStretch",
          pagination:"local",
          paginationSize:10,
          groupToggleElement:"header",
          groupBy:"site_name",
          groupHeader:this.groupHeader,
          groupStartOpen:false,
          columns:[
            {title: 'Synced', field: "is_latest", align:'center', formatter: this.is_latest_formatter, headerSort:false},
            {title: 'Profile', field: "profile", width:200, headerSort:false},
            {title: 'Profile Last Updated At', field: 'profile_last_updated_at', headerSort:false},
            {title: 'Site Delta Timestamp',  field: 'site_delta_timestamp', headerSort:false}
          ],
        },
        syncCount: {
          profilesCount: 0,
          profilesTotal: 0,
          siteCount: 0,
          siteTotal: 0
        },
        isRippleAdmin: secureStorage.getItem("isRippleAdmin"),
        developerMode: secureStorage.getItem("developerMode")
      };
    },
    mounted: async function () {
      component_x = this

      if (this.loggedIn == false && this.developerMode == false) {
        this.$router.push('/')
      } else {
        Object.assign(component_x.spinner, {
          sales: true,
          orders: true,
          terminals: true,
          invoices: true,
          syncs: true,
          accounts: true,
          sites:true,
          terminal_count: true,
          top_accounts_by_terminal: true,
          top_accounts_by_user:true,
          top_accounts_by_site: true,
          pending_invoices: true,
          terminal_license_expiry: true,
          expiry_365_days: true,
          expiry_90_days: true,
          expiry_60_days: true,
          expiry_30_days: true
        })
        if (this.isRippleAdmin || this.developerMode){
          let account_data = []
        
        account_data = await HTTPRequest.getRequest(component_x.endPoint + 'accounts/total_account_counts', null)
        
        if (account_data != undefined) {
          let total_accounts = component_x.formatNumber(Number(account_data.total_accounts))
          Object.assign(component_x.dashboard, {
            total_accounts: `${total_accounts}`
          })
        }
        component_x.spinner.accounts = false

        let expiry_terminal_365_days = []
        
        expiry_terminal_365_days = await HTTPRequest.getRequest(component_x.endPoint + 'accounts/expiry_365_days', null)
        
        if (account_data != undefined) {
          let expiry_terminal_365 = component_x.formatNumber(Number(expiry_terminal_365_days.expiry_365[0]['Terminal Count']))
          Object.assign(component_x.dashboard, {
            expiry_365_days: `${expiry_terminal_365}`
          })
        }
        component_x.spinner.expiry_365_days = false

        let expiry_terminal_90_days = []
        
        expiry_terminal_90_days = await HTTPRequest.getRequest(component_x.endPoint + 'accounts/expiry_90_days', null)
        
        if (expiry_terminal_90_days != undefined) {
          let expiry_terminal_90 = component_x.formatNumber(Number(expiry_terminal_90_days.expiry_90[0]['Terminal Count']))
          Object.assign(component_x.dashboard, {
            expiry_90_days: `${expiry_terminal_90}`
          })
        }
        component_x.spinner.expiry_90_days = false

        let expiry_terminal_60_days = []
        
        expiry_terminal_60_days = await HTTPRequest.getRequest(component_x.endPoint + 'accounts/expiry_60_days', null)
        
        if (expiry_terminal_60_days != undefined) {
          let expiry_terminal_60 = component_x.formatNumber(Number(expiry_terminal_60_days.expiry_60[0]['Terminal Count']))
          Object.assign(component_x.dashboard, {
            expiry_60_days: `${expiry_terminal_60}`
          })
        }
        component_x.spinner.expiry_60_days = false

        let expiry_terminal_30_days = []
        
        expiry_terminal_30_days = await HTTPRequest.getRequest(component_x.endPoint + 'accounts/expiry_30_days', null)
        
        if (expiry_terminal_30_days != undefined) {
          let expiry_terminal_30 = component_x.formatNumber(Number(expiry_terminal_30_days.expiry_30[0]['Terminal Count']))
          Object.assign(component_x.dashboard, {
            expiry_30_days: `${expiry_terminal_30}`
          })
        }
        component_x.spinner.expiry_30_days = false

        let site_data = []
        
        site_data = await HTTPRequest.getRequest(component_x.endPoint + 'sites/total_site_count', null)
        
        if (site_data != undefined) {
          let site_count_ho = null;
          let site_count_branch = null;

          site_data.total_sites.forEach(site => {
            if (site.name === "HO") {
              site_count_ho = site.site_count;
            }
            if (site.name === "Branch") {
              site_count_branch = site.site_count;
            }
          });

          Object.assign(component_x.dashboard, {
            total_sites: `HO: ${site_count_ho} | Branch: ${site_count_branch}`
          });

          
        }
         component_x.spinner.sites = false

         let account_site_data = []
        
         account_site_data = await HTTPRequest.getRequest(component_x.endPoint + 'accounts/top_account_by_sites', null)
        
         if (account_site_data != undefined) {
            const topAccountsBySite = account_site_data.top_sites
              .sort((a, b) => b["Site Count"] - a["Site Count"])
              .slice(0, 5);

            Object.assign(component_x, {
              topAccountsBySite,
            });
          }

          component_x.spinner.top_accounts_by_site = false;

          let account_user_data = []
        
         account_user_data = await HTTPRequest.getRequest(component_x.endPoint + 'accounts/top_account_by_users', null)
        
         if (account_user_data != undefined) {
            const topAccountsByUser = account_user_data.top_users
              .sort((a, b) => b["User Count"] - a["User Count"])
              .slice(0, 5);

            Object.assign(component_x, {
              topAccountsByUser,
            });
          }

          component_x.spinner.top_accounts_by_user = false;

          let account_terminal_data = []
        
          account_terminal_data = await HTTPRequest.getRequest(component_x.endPoint + 'accounts/top_account_by_terminals', null)
       
        if (account_terminal_data != undefined) {
           const topAccountsByTerminal = account_terminal_data.top_terminals
             .sort((a, b) => b["Terminal Count"] - a["Terminal Count"])
             .slice(0, 5);

           Object.assign(component_x, {
            topAccountsByTerminal,
           });
         }

         component_x.spinner.top_accounts_by_terminal = false;

        let terminal_count_data = []
        
        terminal_count_data = await HTTPRequest.getRequest(component_x.endPoint + 'accounts/total_terminal_count', null)
        
        if (terminal_count_data != undefined) {
          let terminal_count = component_x.formatNumber(Number(terminal_count_data.terminal_count))
          Object.assign(component_x.dashboard, {
            terminal_count: `${terminal_count}`
          })
        }
        component_x.spinner.terminal_count = false

        let invoice_data = []
        
        invoice_data = await HTTPRequest.getRequest(component_x.endPoint + 'accounts/pending_invoices', null)
        
        if (invoice_data != undefined) {
          let unprocessed_invoices = invoice_data.unprocessed_invoices
          Object.assign(component_x.dashboard, {
            pending_invoices: `${unprocessed_invoices}`
          })
        }
        component_x.spinner.pending_invoices = false
        }
        if (!this.isRippleAdmin && !this.developerMode) {
        let siteId = secureStorage.getItem("defaultSiteId")
        let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
        if(site != undefined){
            component_x.site_type = site.site_type
        }

        let sales_data = []
        if(component_x.site_type == 'branch'){
          sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/pos_document_summary?site_id=' + siteId, null)
        } else {
          sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/pos_document_summary', null)
        }

        if(sales_data != undefined){
          let total_sales = component_x.convertToCurrency(Number(sales_data.total_sales))
          let total_returns = component_x.convertToCurrency(Number(sales_data.total_returns))

          Object.assign(component_x.dashboard, {
            total_sales: total_sales,
            total_return: total_returns,
          })
        }
        component_x.spinner.sales = false

        let order_data = []
        if(component_x.site_type == 'branch'){
          order_data = await HTTPRequest.getRequest(component_x.endPoint + 'documents/sales_order_summary?site_id=' + siteId, null)
        } else {
          order_data = await HTTPRequest.getRequest(component_x.endPoint + 'documents/sales_order_summary', null)
        }

        if(order_data != undefined){
          let total_fulfilled = component_x.formatNumber(Number(order_data.total_fulfilled))
          let total_pending = component_x.formatNumber(Number(order_data.total_pending))

          Object.assign(component_x.dashboard, {
            total_fulfilled: total_fulfilled,
            total_pending: total_pending,
          })
        }
        component_x.spinner.orders = false

        let terminal_data = []
        if(component_x.site_type == 'branch'){
          terminal_data = await HTTPRequest.getRequest(component_x.endPoint + 'terminals/terminal_summary?site_id=' + siteId, null)
        } else {
          terminal_data = await HTTPRequest.getRequest(component_x.endPoint + 'terminals/terminal_summary', null)
        }

        let session_data = []
        if (component_x.site_type == 'branch') {
          session_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_sessions?session_count=1&site_id=' + siteId + '&business_date=' + moment().format("YYYY-MM-DD"), null)
        } else {
          session_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_sessions?session_count=1&business_date=' + moment().format("YYYY-MM-DD"), null)
        }

        // STARTS Here
        if (terminal_data != undefined) {
          let total_sessions = component_x.formatNumber(Number(session_data.total_sessions))
          let total_terminals = component_x.formatNumber(Number(terminal_data.total_terminals))

          // Object.assign(component_x.dashboard, {
          //   total_terminals: component_x.site_type !== 'branch' ? `${total_sessions}` : `${total_sessions} / ${total_terminals}`
          // })
          Object.assign(component_x.dashboard, {
            total_terminals: `${total_sessions} / ${total_terminals}`
          })
        }
        component_x.spinner.terminals = false
        // ENDS here

        let stats = []
        if(component_x.site_type == 'branch'){
          stats = await HTTPRequest.getRequest(this.endPoint + "api_invoices/get_stats?business_date=" + moment().format("YYYY-MM-DD") + '&site_id=' + siteId, null)
        } else {
          stats = await HTTPRequest.getRequest(this.endPoint + "api_invoices/get_stats?business_date=" + moment().format("YYYY-MM-DD"), null)
        }

        if(stats != undefined){
          Object.assign(component_x.invoiceStatus, {
            completedStats: Number(stats.no_of_completed),
            unprocessedStats: Number(stats.no_of_unprocessed),
            errorStats: Number(stats.no_of_error)
          })

          component_x.pieData = component_x.invoiceStatus.completedStats + component_x.invoiceStatus.unprocessedStats + component_x.invoiceStatus.errorStats
          component_x.chartOptions.data.datasets[0].data = [component_x.invoiceStatus.completedStats,
            component_x.invoiceStatus.unprocessedStats,
            component_x.invoiceStatus.errorStats]

          myChart = new Chart("myChart", component_x.chartOptions);
        }
        component_x.spinner.invoices = false

        let syncs = []
        component_x.syncCount = {
          profilesCount: 0,
          profilesTotal: 0,
          siteCount: 0,
          siteTotal: 0
        }

        if(component_x.site_type == 'branch'){
          syncs = await HTTPRequest.getRequest(this.endPoint + 'branch_delta_sync_details?site_id=' + secureStorage.getItem("defaultSiteId"), null)
        } else {
          syncs = await HTTPRequest.getRequest(this.endPoint + 'branch_delta_sync_details', null)
        }

        component_x.syncData = syncs
        let unique = [];
        let distinct = [];
        for( let i = 0; i < component_x.syncData.length; i++ ){
          if( !unique[component_x.syncData[i].site_name]){
            distinct.push(component_x.syncData[i].site_name);
            let value = component_x.syncData[i].site_name
            let is_latest_count = component_x.syncData.filter(d => d.is_latest=="Yes" && d.site_name == value).length
            let site_count = component_x.syncData.filter(d => d.site_name == value).length
            if(is_latest_count == site_count){
              component_x.syncCount.siteCount += 1
            }
            Object.assign(this.syncCount, {
              profilesCount: component_x.syncCount.profilesCount + is_latest_count,
              profilesTotal: component_x.syncCount.profilesTotal + site_count
            })
            unique[component_x.syncData[i].site_name] = 1;
          }
        }
        component_x.syncCount.siteTotal = distinct.length
        component_x.spinner.syncs = false
        } // end of if (!this.isRippleAdmin && !this.developerMode)
        console.log(secureStorage.getItem("accessToken"))
      }
    },
    methods: {
      ...mapActions(['updateCurrentProfile']),
      moment,
      formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      convertToCurrency(num){
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      redirectUser(type) {
        if (type == 'invoices') {
          this.setCurrentProfile('pos_sales_dashboards');
        } else if(type == 'syncs'){
          if(this.serverType == 'branch'){
            this.setCurrentProfile('terminal_delta_sync_details');
          } else {
            this.setCurrentProfile('branch_delta_sync_details');
          }
        }
        const expiry_cap = ['365', '90', '60', '30'];

        if (expiry_cap.includes(type)) {
          this.$router.push(`/expiry_date/${type}`);
        } else {
          this.$router.push('/tools');
        }
      },
      setCurrentProfile(profile) {
        this.updateCurrentProfile(profile);
      },
      is_latest_formatter: function(cell, formatterParams, onRendered){
        var is_latest_format = ''
        var is_latest = cell.getValue();

        if (is_latest == 'Yes')
          is_latest_format = "<span style='color: #00ff00;'><i class='fas fa-sync-alt'></i></span>"
        else
          is_latest_format = "<span style='color: #ff0000;'><i class='far fa-times-circle'></i></span>"

        return is_latest_format;
      },
      groupHeader:function(value, count, data, group){
        var is_latest_count = this.syncData.filter(d => d.is_latest=="Yes" && d.site_name == value).length
        var site_count = this.syncData.filter(d => d.site_name == value).length

        var group_sync_status = ''
        if (is_latest_count == site_count)
          group_sync_status = "<span style='color: #00ff00;'><i class='fas fa-sync-alt'></i></span>"
        else
          group_sync_status = "<span style='color: #ff0000;'><i class='fas fa-times-circle'></i></span>"

        var arrow_key = ''
        if (group._group.visible) {
          arrow_key = "<i class='fas fa-chevron-down'></i>"
        } else {
          arrow_key = "<i class='fas fa-chevron-right'></i>"
        }
        return arrow_key + group_sync_status + "  " + value + "<span style='color:#6468E3; margin-left:10px;'>" + is_latest_count + " out of "+ site_count + " profile(s) synced</span>";
      },
    }
  };
</script>
<style lang='scss'>
  @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
  .tabulator-group-toggle{
    display: none;
  }
  .ant-spin-nested-loading,
  .ant-spin-container{
    height: 100%;
  }

  .active-terminals{
    font-size: 20px;
  }
  </style>
